import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@mdsol/onex-design'

interface PropertySearchBulkActionHeaderProps {
  selectedCount: number
  isAllDataSelected: boolean
  totalCount: number | null
  isCountLoading: boolean
  onSelectAll: () => void
  onClearSelection: () => void
}

const PropertySearchBulkActionHeader: React.FC<PropertySearchBulkActionHeaderProps> = ({
  selectedCount,
  isAllDataSelected,
  totalCount,
  isCountLoading,
  onSelectAll,
  onClearSelection
}) => {
  const { t } = useTranslation()

  if (selectedCount === 0 && !isAllDataSelected) return null

  const displayCount = isAllDataSelected && totalCount !== null ? totalCount : selectedCount

  return (
    <div className="onex-data-grid-bulk-actions property-search-bulk-header">
      <div className="onex-data-grid-bulk-actions__counter counter">
        <span className="onex-data-grid-bulk-actions__counter_text">
          {t('PROPERTIES_SEARCH_MULTISELECT_N_SELECTED', { count: displayCount })}
        </span>
      </div>
      <div className="onex-data-grid-bulk-actions__actions hasActions">
        <div className="onex-data-grid-bulk-actions__select-all-wrapper">
          {!isAllDataSelected && (
            <Button
              variant="primary"
              size="sm"
              buttonStyle="ghost"
              className="select-all-btn"
              onClick={onSelectAll}
              disabled={isCountLoading}
            >
              {isCountLoading
                ? `${t('PROPERTIESSEARCH_MULTISELECT_SELECT_ALL_IN_SECTION', { allItems: '...' })}`
                : t('PROPERTIESSEARCH_MULTISELECT_SELECT_ALL_IN_SECTION', { allItems: totalCount ?? '' })}
            </Button>
          )}
          <Button
            variant="secondary"
            buttonStyle="ghost"
            size="sm"
            className="clear-selection-btn"
            onClick={onClearSelection}
          >
            {t('CLEAR_SELECTED')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default PropertySearchBulkActionHeader
